import { constants as config } from '@config';

import { instance as CompanyFactory } from '../editor/factory/company';
import { convertUnitsToPixels } from '../helpers/convert-units-to-pixels';
import converterCurrentPage from '../helpers/converter-current-page';
import { isDataURL } from '../helpers/dataUrl';
import { sanitizeIgnoredTagsSvg, sanitizeIgnoredSaveTagsSvg } from '../helpers/fixPageSvg';
import { getInlineSize } from '../helpers/get-inline-size';
import { isElementInCanvas, isElementPartiallyInCanvas } from '../helpers/is-element-in-canvas';
import { handleMutationEvent } from '../helpers/mutation-events-helper';
import { getCursorLineIndex, getLineArray, getStylingPart } from '../helpers/textCursorHelper';
import cookieStorage from '../editor/utils/cookie-storage';
import ActionPrompt from 'src/views/action-prompt';

export default () => {
  INKIVE.Helpers = {};
  INKIVE.Helpers.systemDeferred = null;
  INKIVE.Helpers.isDataURL = isDataURL;

  INKIVE.Helpers.afterRendering = function (callback) {
    window.requestAnimFrame || initRequestFunction();
    window.requestAnimFrame(function () {
      window.requestAnimFrame(callback);
    });

    function initRequestFunction () {
      window.requestAnimFrame = (function () {
        return window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          function (callback) { setTimeout(callback, 1000 / 60); };
      })();
    }
  };

  INKIVE.Helpers.loadVisitorModal = function (url, data, callback, script) {
    $.ajax({
      type: 'GET',
      url: INKIVE.C.BASE_URL + url,
      dataType: 'html',
      data,
      async: true,
      success: function (modalContent) {
        $(modalContent).insertAfter($('#content'));

        script
          ? $.getScript(CONFIG[script]).done(callback)
          : callback();
      }
    });
  };

  INKIVE.Helpers.displaySubscriptionModal = function (description, plan = config.plans.pro, skipTrial = false,
    companyDomain = null, paymentOptions = null, callbackFunction = null
  ) {
    const isBusinessSignup = plan === config.plans.business;
    const path = isBusinessSignup ? 'white-label/components/onboarding-modal/main' : 'payment/main';
    let paymentApp = document.querySelector(`[aurelia-app="${path}"]`);
    INKIVE.Modal.togglePageLoader(true);

    paymentApp
      ? displayPaymentModal()
      : INKIVE.Helpers.loadVisitorModal('content/visitormodal', { url: 'payment-modal' }, displayPaymentModal);

    function displayPaymentModal () {
      if (!paymentApp && isBusinessSignup) {
        const div = document.createElement('div');
        div.setAttribute('aurelia-app', path);

        document.body.appendChild(div);
        CONFIG.base_host = INKIVE.C.WE_BRAND.match(/\/\/([^/]+)/)[1];
        CONFIG.host_desygner = INKIVE.C.BASE_URL.match(/\/\/([^/]+)/)[1];
        CONFIG.uppy_companion_url = INKIVE.C.uppy_companion_url;
        CONFIG.pro_user = true;
        CONFIG.s3_bucket = INKIVE.C.BUCKET;
        Object.assign(CONFIG.addons, {
          uploader_config: {
            id: 'uploader_config',
            features: INKIVE.C.FEATURE_FLAG.uploader_config
          }
        });
      }

      paymentApp = paymentApp || document.querySelector(`[aurelia-app="${path}"]`);

      INKIVE.Helpers.getAureliaLibraries($(paymentApp)).then(async function () {
        const workspace = await CompanyFactory.getCompanyData();

        if (INKIVE.UserInfoFactory.isBusinessTrialUser() && !INKIVE.Helpers.isDesygnerProject()) {
          plan = config.plans.proTeam;
          skipTrial = true;
          companyDomain = workspace.domain;
        }

        if (paymentOptions && paymentOptions.upgradeFlavour === 'one-time') {
          paymentApp.dataset.flavour = paymentOptions.upgradeFlavour;
          paymentApp.dataset.product = paymentOptions.product;
          delete paymentApp.dataset.plan;
          delete paymentApp.dataset.interval;
        } else {
          paymentApp.dataset.plan = isBusinessSignup ? config.plans.proTeam : plan;
          paymentApp.dataset.flavour = plan === config.plans.content2 ? 'content' : 'plan';
        }

        paymentApp.dataset.skipTrial = skipTrial || plan === config.plans.pro;
        plan === config.plans.pro && (paymentApp.dataset.forceCC = true);
        companyDomain && (paymentApp.dataset.companyDomain = companyDomain);

        _.delay(function () {
          const detail = paymentOptions || {
            customisation: workspace.is_customisation_preview,
            paymentOnly: workspace.is_customisation_preview,
            companyId: CompanyFactory.companyId,
            isBusinessSignup
          };

          if (plan === config.plans.content2) {
            detail.setPayment = true;
          }

          if (plan === config.plans.proTeam && detail.customisation) {
            detail.companyDomain = workspace.domain;
          }

          paymentApp.dispatchEvent(new CustomEvent(isBusinessSignup ? 'onboarding:open-modal' : 'payment.modal.toggle', { detail }));
        }, 100);

        $('.ui-dropdown-content[data-id="versions"]').hide();

        const modal = paymentApp.querySelector('.modal');
        const modalDescription = modal && modal.querySelector('.upgrade-modal__description');

        if (modal && modalDescription) {
          modalDescription.innerHTML = INKIVE.TranslateHelper.translate(description);
        }

        if (paymentApp && plan !== config.plans.proTeam) {
          paymentApp.addEventListener('payment.success', callbackFunction || redirect);
        }

        INKIVE.Modal.togglePageLoader(false);

        function redirect () {
          INKIVE.EditorFacade.handle('page', 'save').then(function () {
            paymentApp.remove();
            INKIVE.Modal.togglePageLoader(true);
            window.location.reload();
          });
        }
      });
    }
  };

  INKIVE.Helpers.isCredentialsValid = async () => {
    try {
      const forceReload = true;
      const response = await INKIVE.UserInfoFactory.get(forceReload);

      return !!response.credentials;
    } catch (error) {
      return false;
    }
  };

  INKIVE.Helpers.deleteCredentials = async () => {
    if (INKIVE.C.IS_MOBILE) return;

    try {
      delete CONFIG.credentials;
      delete CONFIG.api_key;

      cookieStorage.delete('user_token');
      cookieStorage.delete('user_hash');
    } catch (error) {
      console.error('Error deleting credentials', error);
    }
  };

  INKIVE.Helpers.displayAccessModal = async function ({
    useLoginModal = false
  } = {}) {
    if (INKIVE.C.IS_MOBILE) return;

    INKIVE.Helpers.deleteCredentials();
    INKIVE.Modal.togglePageLoader(true);

    const whiteLabel = INKIVE.C.WHITE_LABEL_CONFIGURATION;
    const isKW = whiteLabel.domain === 'kw' || (whiteLabel.parent_company && whiteLabel.parent_company === 'kw');

    if (whiteLabel.sso_only && !isKW) {
      revalidateCredentialsForSSO();
      INKIVE.Modal.togglePageLoader(false);

      return;
    }

    const accessApp = getModalContainer();

    if (accessApp.getAttribute('data-status') === 'loaded') {
      showAccessModal();
      INKIVE.Modal.togglePageLoader(false);

      return;
    }

    await INKIVE.Helpers.getAureliaLibraries($(accessApp));

    INKIVE.Modal.togglePageLoader(false);

    accessApp.setAttribute('data-status', 'loaded');

    document.addEventListener('access:modal.loaded', showAccessModal, {
      once: true
    });

    function showAccessModal () {
      const accessApp = getModalContainer();
      const detail = {
        mode: 'login',
        useCaptcha: true,
        closeOnClick: false,
        allowSignup: false
      };

      document.addEventListener('access:modal.loggedin', (event) => {
        if (event.detail) {
          INKIVE.PageFactory.updateCredentials(event.detail.api_key);
          INKIVE.C.IS_AUTO_SAVE && INKIVE.EditorFacade.handle('page', 'save');
        }
      }, { once: true });

      accessApp.dispatchEvent(new CustomEvent('access:modal.open', { detail }));

      INKIVE.Modal.togglePageLoader(false);
    }

    function getModalContainer () {
      const whiteLabel = INKIVE.C.WHITE_LABEL_CONFIGURATION;
      const appFlavour = whiteLabel.supports_sso ? 'sso' : 'captcha';
      const element = document.querySelector('[aurelia-app="access/main"]');
      CONFIG.addons.white_label.config ?? (CONFIG.addons.white_label.config = whiteLabel);

      if (element) return element;

      const div = document.createElement('div');
      div.setAttribute('aurelia-app', 'access/main');
      div.setAttribute('app-flavour', appFlavour);
      div.setAttribute('data-status', 'loading');
      document.body.appendChild(div);

      return div;
    }

    function revalidateCredentialsForSSO () {
      const whiteLabel = INKIVE.C.WHITE_LABEL_CONFIGURATION;
      const subdomain = whiteLabel.domain;
      const domain = window.location.host;
      const labels = {
        title: INKIVE.TranslateHelper.translate('modal.revalidate_credentials.title'),
        subtitle: INKIVE.TranslateHelper.translate('modal.revalidate_credentials.subtitle'),
        button: {
          title: INKIVE.TranslateHelper.translate('modal.revalidate_credentials.button.title'),
          loading: INKIVE.TranslateHelper.translate('modal.revalidate_credentials.button.loading')
        }
      };

      ActionPrompt.mountApp({
        labels,
        onClick: () => {
          window.open(`https://${subdomain}.${domain}/login`);
          cookieStorage.set('referer', `https://${domain}/revalidate`, null, `.${domain}`);
        }
      });

      const channel = new BroadcastChannel('desygner_editor');
      channel.onmessage = async (event) => {
        if (!event.data.revalidateCredentials) return;

        CONFIG.credentials = {
          hash: event.data.credentials.userHash,
          token: event.data.credentials.userToken
        };

        channel.postMessage({ finished: true });
        await INKIVE.UserInfoFactory.get(true);
        INKIVE.PageFactory.updateCredentials(CONFIG.credentials.api_key);
        INKIVE.C.IS_AUTO_SAVE && INKIVE.EditorFacade.handle('page', 'save');
        cookieStorage.delete('referer');
        ActionPrompt.closeApp();
        channel.close();
      };
    }
  };

  INKIVE.Helpers.getTimestamp = function () {
    const ms = new Date().getTime();
    return Math.floor(ms / 1000);
  };

  INKIVE.Helpers.log = function (level, message, data) {
    const xhr = new XMLHttpRequest();

    xhr.open('POST', INKIVE.C.WE_BRAND + 'untidy-api/log/' + level);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      name: 'Editor exception: ' + message,
      data: typeof data === 'object' ? data : {}
    }));
  };

  INKIVE.Helpers.isInt = function (n) {
    if (isNaN(n)) return false;

    return Number(n) === n && n % 1 === 0;
  };

  INKIVE.Helpers.isFloat = function (n) {
    if (isNaN(n)) return false;
    return Number(n) === n && n % 1 !== 0;
  };

  INKIVE.Helpers.isShallowEqual = function (obj1, obj2) {
    return Object.keys(obj2).every(function (key) {
      return Object.prototype.hasOwnProperty.call(obj1, key) && obj1[key] === obj2[key];
    });
  };

  INKIVE.Helpers.projectIsLinkedToRestrictions = function () {
    return INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN ||
      INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;
  };

  INKIVE.Helpers.isDesygnerProject = function () {
    return INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESIGN ||
      INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN;
  };

  INKIVE.Helpers.isWeBrandProject = function () {
    return INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN ||
      INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN ||
      INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;
  };

  INKIVE.Helpers.isWeBrandTemplate = function () {
    return INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;
  };

  INKIVE.Helpers.getPrintGuidelinesProject = function () {
    return INKIVE.C.PRINTING_TYPE?.print_type;
  };

  INKIVE.Helpers.getFragmentTarget = function () {
    const hash = window.location.hash;
    const action = hash.split(':');
    return action[0];
  };

  INKIVE.Helpers.getCORSSecureUrl = function (url) {
    /*
     * This function gets called in a lot of places
     * The goal is to replace the various URLs with CloudFront (our CDN) urls
     * This function doesn't attempt to check whether the url is actually reachable
     */

    let newUrl = url;
    if (url && typeof url === 'string' && !isDataURL(url)) {
      let path;
      const pathStartsWithSlash = url.match(/^\/.*/);
      if (pathStartsWithSlash) path = pathStartsWithSlash[0];
      const pathMatchesDomain = url.match(/.*\/([^/\s]+(inkive|desygner|webrand|photodexia)[^/\s]+\/)(.*)/);
      if (pathMatchesDomain) path = pathMatchesDomain[3];

      if (path) {
        if (INKIVE.C.IS_QA || INKIVE.C.IS_DEV) newUrl = `https://static.qadesygner.xyz/${path}`;
        else newUrl = `https://static.desygner.com/${path}`;
      }
    }

    if (newUrl !== url && INKIVE.C.DEBUG) {
      console.log(`[getCORSSecureUrl] modified url:\n${url}\n=> ${newUrl}`);
    }

    return newUrl;
  };

  INKIVE.Helpers.getFragmentParam = function (key) {
    const hash = window.location.hash;

    let returnValue = null;
    $.each(hash.split(':'), function (index, elem) {
      const data = elem.split('=');
      if (data[0] === key) {
        returnValue = data[1];
        return false;
      }
    });

    return returnValue;
  };

  /**
   * executeFunctionByName("My.Namespace.functionName", window, arguments);
   * executeFunctionByName("Namespace.functionName", My, arguments);
   */
  INKIVE.Helpers.executeFunctionByName = function (functionName, context /*, args */) {
    if (!functionName) {
      return null;
    }

    const args = [].slice.call(arguments).splice(2);
    const namespaces = functionName.split('.');
    const func = namespaces.pop();

    for (let i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]];
    }

    return context[func].apply(context, args ? args.pop() : null);
  };

  INKIVE.Helpers.dataURLToBlob = function (dataURL) {
    if (!isDataURL(dataURL)) {
      return null;
    }
    let parts,
      contentType,
      raw;

    const BASE64_MARKER = ';base64,';
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
      parts = dataURL.split(',');
      contentType = parts[0].split(':')[1];
      raw = decodeURIComponent(parts[1]);

      return new Blob([raw], { type: contentType });
    }

    parts = dataURL.split(BASE64_MARKER);
    contentType = parts[0].split(':')[1];
    raw = window.atob(parts[1]);
    const rawLength = raw.length;

    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  };

  INKIVE.Helpers.isEmail = function (email) {
    if (!email || !email.length) {
      return false;
    }

    const regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  };

  INKIVE.Helpers.isUrlValid = function (url) {
    if (url.match(/^#\d+$/)) {
      return true;
    }

    return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i.test(
      url);
  };

  INKIVE.Helpers.convertUnitsToPixels = convertUnitsToPixels;

  INKIVE.Helpers.convertPixelsToUnits = function (val, unit, decimalValue, dpi) {
    val = parseFloat(val);
    let rez;
    const inToCmFactor = 2.54;

    dpi = dpi || INKIVE.C.DPI;

    switch (unit) {
      case 'cm':
        rez = (val / dpi) * inToCmFactor;
        break;
      case 'mm':
        rez = INKIVE.Helpers.convertPixelsToUnits(val * 10, 'cm', decimalValue, dpi);
        break;
      case 'in':
        rez = INKIVE.Helpers.convertPixelsToUnits(val / inToCmFactor, 'cm', decimalValue, dpi);
        break;
      default:
        rez = decimalValue ? val : Math.round(val);
    }

    return rez;
  };

  INKIVE.Helpers.getSelectedCoordinates = function (selected) {
    const selector = svgedit.select.getSelectorManager().requestSelector(selected);
    if (selector) {
      const canvas = INKIVE.Tool.getInstance().editor.canvas;
      const bb = selector.transformBox.abbox;
      const rotate = canvas.getRotationAngle(selected);

      const box = INKIVE.Helpers.getTransformPoints(bb, 0, rotate, 0, 0);

      return {
        sx: 0,
        sy: 0,
        x1: box.tl.x, // top left horizontal
        y1: box.tl.y,
        x2: box.tr.x, // top right horizontal
        y2: box.tr.y,
        x3: box.bl.x, // bottom left horizontal
        y3: box.bl.y,
        x4: box.br.x, // bottom right horizontal
        y4: box.br.y,
        x5: box.m.x, // middle horizontal
        y5: box.m.y
      };
    }
  };

  INKIVE.Helpers.getHoveredCoordinates = function (hovered, zoom = 1) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const bb = svgedit.utilities.getBBox(hovered);
    const rotate = canvas.getRotationAngle(hovered);
    const box = INKIVE.Helpers.getTransformPoints(bb, 0, rotate, 0, 0);

    return {
      sx: 0,
      sy: 0,
      x1: box.tl.x * zoom, // top left horizontal
      y1: box.tl.y * zoom,
      x2: box.tr.x * zoom, // top right horizontal
      y2: box.tr.y * zoom,
      x3: box.bl.x * zoom, // bottom left horizontal
      y3: box.bl.y * zoom,
      x4: box.br.x * zoom, // bottom right horizontal
      y4: box.br.y * zoom,
      x5: box.m.x * zoom, // middle horizontal
      y5: box.m.y * zoom
    };
  };

  INKIVE.Helpers.getTransformCoordinates = function (bb, offset, angle, cx, cy) {
    const box = INKIVE.Helpers.getTransformPoints(bb, offset, angle, cx, cy);

    const rcr = $('#svgroot').get(0).getBoundingClientRect();
    const ccr = $('#canvasBackground').get(0).getBoundingClientRect();

    const offsetX = ccr.left - rcr.left;
    const offsetY = ccr.top - rcr.top;

    return {
      sx: 0,
      sy: 0,
      x1: offsetX + box.tl.x, // top left horizontal
      y1: offsetY + box.tl.y,
      x2: offsetX + box.tr.x, // top right horizontal
      y2: offsetY + box.tr.y,
      x3: offsetX + box.bl.x, // bottom left horizontal
      y3: offsetY + box.bl.y,
      x4: offsetX + box.br.x, // bottom right horizontal
      y4: offsetY + box.br.y,
      x5: offsetX + box.m.x, // middle horizontal
      y5: offsetY + box.m.y
    };
  };

  INKIVE.Helpers.getObjectCoordinatesByDirection = function (canvas, object, toRight, toBottom) {
    const coord = INKIVE.Helpers.getObjectCoordinates(canvas, object);

    if (toRight) {
      delete coord.x1;
      delete coord.y1;
      delete coord.x3;
      delete coord.y3;
    } else {
      delete coord.x2;
      delete coord.y2;
      delete coord.x4;
      delete coord.y4;
    }

    if (toBottom) {
      delete coord.x1;
      delete coord.y1;
      delete coord.x2;
      delete coord.y2;
    } else {
      delete coord.x3;
      delete coord.y3;
      delete coord.x4;
      delete coord.y4;
    }

    return coord;
  };

  INKIVE.Helpers.getObjectCoordinates = function (canvas, object) {
    const selected = $('#' + object.id).get(0);
    if (!selected) return;
    const sw = selected.getAttribute('stroke-width');
    const zoom = canvas.getZoom();
    let offset = 1.0 / zoom;

    // remove selection border
    offset -= 1.0 / 2;

    if (selected.getAttribute('stroke') !== 'none' && !isNaN(sw)) {
      offset += (sw / 2);
    }

    offset *= zoom;

    const bb = {
      x: object.x * zoom,
      y: object.y * zoom,
      width: object.width * zoom,
      height: object.height * zoom,
      rotate: object.rotate
    };

    return INKIVE.Helpers.getTransformCoordinates(bb, offset, bb.rotate);
  };

  INKIVE.Helpers.getTransformPoints = function (bb, offset, angle, cx, cy) {
    offset = offset || 0;
    angle = angle || 0;

    const box = {
      tl: {
        x: bb.x - offset,
        y: bb.y - offset
      },
      tr: {
        x: bb.x + bb.width + offset,
        y: bb.y - offset
      },
      bl: {
        x: bb.x - offset,
        y: bb.y + bb.height + offset
      },
      br: {
        x: bb.x + bb.width + offset,
        y: bb.y + bb.height + offset
      },
      m: {
        x: bb.x + bb.width / 2 + offset,
        y: bb.y + bb.height / 2 + offset
      }
    };

    if (angle) {
      cx = cx || box.m.x;
      cy = cy || box.m.y;

      const rot = document.querySelector('#svgroot').createSVGTransform();
      rot.setRotate(angle, cx, cy);

      for (const key in box) {
        box[key] = svgedit.math.transformPoint(box[key].x, box[key].y, rot.matrix);
      }
    }

    return box;
  };

  INKIVE.Helpers.TransformPointBox = function (bb, id) {
    id = id || 1;

    const dstr = 'M' + bb.tl.x + ',' + bb.tl.y +
      ' L' + bb.tr.x + ',' + bb.tr.y +
      ' ' + bb.br.x + ',' + bb.br.y +
      ' ' + bb.bl.x + ',' + bb.bl.y + 'z';

    let block;
    if (!$('#svgcontent .tpBox_' + id).length) {
      block = document.createElementNS(svgedit.NS.SVG, 'path');

      svgedit.utilities.assignAttributes(block, {
        fill: '#' + Math.floor(Math.random() * 0xffffff).toString(16),
        opacity: 0.5,
        style: 'pointer-events:none',
        class: 'tpBox_' + id
      });

      $('#svgcontent').get(0).appendChild(block);
    } else {
      block = $('#svgcontent .tpBox_' + id).get(0);
    }

    svgedit.utilities.assignAttributes(block, {
      d: dstr,
      display: 'inline'
    });
  };

  INKIVE.Helpers.getFileNameFromUrl = function (url) {
    return url.split('/').pop();
  };

  INKIVE.Helpers.getFileExt = function (filename) {
    return filename.substr(filename.lastIndexOf('.') + 1).toLowerCase();
  };

  INKIVE.Helpers.getShareUrl = function () {
    if (INKIVE.Helpers.isWeBrandProject()) {
      return INKIVE.C.VIEWER +
        (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE ? 'template/' : '') +
        INKIVE.C.BOOK.encodedId +
        '?t=' + _.now();
    }

    const profiletypetemp = 'view-' + INKIVE.C.USER.id;
    const urlText = Base64.decode(INKIVE.C.BOOK.name).toLowerCase().replace(/ /g, '_').replace('/[^a-z0-9]+/', '_');

    return '%s/%s/%s/%s_%s.html'.sprintf(
      INKIVE.C.BASE_URL + 'design/preview',
      INKIVE.C.BOOK.encodedId,
      profiletypetemp,
      urlText,
      INKIVE.Helpers.getTimestamp());
  };

  INKIVE.Helpers.fillFacebookOGTags = function (url) {
    const config = INKIVE.C.WHITE_LABEL_CONFIGURATION;

    const ogtags = { title: '', description: '' };

    if (config.domain === undefined) {
      ogtags.title = 'Made with <3 on Desygner.com';
      ogtags.description = 'https://www.desygner.com/';
    }

    // this is a hotfix & workaround to mitigate a redfin complaint
    // due to facebook limitation
    if (config.domain === 'redfin') {
      ogtags.title = 'Redfin';
      ogtags.description = 'https://www.redfin.com/';
    }

    return url + '&isFacebook=' + btoa(JSON.stringify(ogtags));
  };

  INKIVE.Helpers.getShareNetworkUrl = function (network, url) {
    switch (network) {
      case 'facebook':
        return INKIVE.Helpers.getFBUrl(url);
      case 'twitter':
        return INKIVE.Helpers.getTwitterUrl(url);
      case 'linkedin':
        return INKIVE.Helpers.getLinkedinUrl(url);
      case 'google':
        return INKIVE.Helpers.getGoogleplusUrl(url);
    }
  };

  INKIVE.Helpers.fillFacebookOGTags = function (url) {
    const config = INKIVE.C.WHITE_LABEL_CONFIGURATION;

    const ogtags = { title: '', description: '' };

    if (config.domain === undefined) {
      ogtags.title = 'Made with <3 on Desygner.com';
      ogtags.description = 'https://www.desygner.com/';
    }

    // this is a hotfix & workaround to mitigate a redfin complaint
    // due to facebook limitation
    if (config.domain === 'redfin') {
      ogtags.title = 'Redfin';
      ogtags.description = 'https://www.redfin.com/';
    }

    return url + '&isFacebook=' + btoa(JSON.stringify(ogtags));
  };

  INKIVE.Helpers.getFBUrl = function (url) {
    url = url || INKIVE.Helpers.getShareUrl();
    return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
  };

  INKIVE.Helpers.getTwitterUrl = function (url) {
    url = url || INKIVE.Helpers.getShareUrl();
    return 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url);
  };

  INKIVE.Helpers.getLinkedinUrl = function (url) {
    url = url || INKIVE.Helpers.getShareUrl();
    return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url);
  };

  INKIVE.Helpers.getGoogleplusUrl = function (url) {
    url = url || INKIVE.Helpers.getShareUrl();
    return 'https://plus.google.com/share?url=' + encodeURIComponent(url);
  };

  INKIVE.Helpers.sendCmd = function (sUrl, sData, sFunction, ms, type) {
    ms = ms || this.c;
    type = type || 'POST';

    function errorCheck (status) {
      if (status === 200) return true;

      INKIVE.Modal.alertMessage('<b>Error - </b><i>Network</i><b><br>Please check network</b>');
      return false;
    }

    $.ajax({
      type,
      url: sUrl,
      timeout: ms,
      dataType: 'json',
      data: sData,
      complete: function (r) {
        if (errorCheck(r.status)) {
          $.when(sFunction(r.responseText)).done(function (d) {

          });
        }
      }
    });
  };

  INKIVE.Helpers.api = function (api, method, params, callback) {
    const url = INKIVE.C.BASE_URL + 'api/' + api;

    $.api(url, method, params, function (r, boolen, status, errorCode, userMessage) {
      const isCalbackAFunction = typeof (callback) === 'function';

      isCalbackAFunction && callback(r, boolen, status, errorCode, userMessage);
      isCalbackAFunction || alert(userMessage);
    });
  };

  INKIVE.Helpers.apiMultipart = function (route, formData, callback) {
    const url = INKIVE.C.BASE_URL + 'api/' + route;
    const data = new FormData();

    _.each(formData, function (value, key) {
      data.append(key, value);
    });

    $.apiMultipart(url, data, function (r, boolen, status, errorCode, userMessage) {
      const isCalbackAFunction = typeof (callback) === 'function';

      isCalbackAFunction && callback(r, boolen, status, errorCode, userMessage);
      isCalbackAFunction || alert(userMessage);
    });
  };

  INKIVE.Helpers.isResponseExists = function (data) {
    return !(!data || data.length === 0);
  };

  INKIVE.Helpers.isElementInCanvas = isElementInCanvas;
  INKIVE.Helpers.isElementPartiallyInCanvas = isElementPartiallyInCanvas;

  INKIVE.Helpers.imageLoader = function (url, callback, timeout) {
    timeout = timeout || INKIVE.C.Timeout.imageCheck;

    let timedOut = false;
    const img = new Image();

    img.onerror = img.onabort = function () {
      if (!timedOut) {
        clearTimeout(timer);
        callback(INKIVE.C.Status.error, img);
      }
    };

    img.onload = function () {
      if (!timedOut) {
        clearTimeout(timer);
        callback(INKIVE.C.Status.success, img);
      }
    };

    img.src = url;
    const timer = setTimeout(function () {
      timedOut = true;
      callback(INKIVE.C.Status.timeout, img);
    }, timeout);
  };

  INKIVE.Helpers.initTooltips = function ($elem, options) {
    $elem = $elem || $('body');

    // Ignore this for mobile
    if (INKIVE.C.IS_MOBILE) {
      return;
    }

    //  Init tooltips for right menu
    $elem.find('[data-popover="tooltip-titled-buttons"]').each(function () {
      $(this).tooltip($.extend({
        placement: $(this).data('placement') || 'auto',
        html: true,
        customTemplate: true
      }, options));
    });

    //  Init tooltips for right menu
    $elem.find('[data-popover="tooltip"]').each(function () {
      $(this).tooltip($.extend({
        placement: $(this).data('placement') || 'auto',
        html: true
      }, options));
    });
  };

  INKIVE.Helpers.initPopover = function ($elem, options) {
    $elem = $elem || $('body');

    // Ignore this for mobile
    if (INKIVE.C.IS_MOBILE) {
      return;
    }

    $elem.find('[data-popover="popover"]').popover($.extend({
      trigger: 'hover',
      html: true
    }, options));

    $elem.find('[data-popover="popover"]').on('shown.bs.popover', function (e) {
      $('.popover').css('left', $('#tool-panel').width());
    });
  };

  INKIVE.Helpers.saveToDisk = function (fileURL, fileName) {
    let url = INKIVE.C.BASE_URL + 'editor/file?url=' + encodeURIComponent(fileURL);
    let statusMsg = INKIVE.TranslateHelper.translate('general.starting_download');
    const updateStatus = _.throttle(status, 100);
    const $downloadButtons = $('[data-action="download-action"]');

    fetchUrl(url);

    async function fetchUrl (url) {
      updateStatus();
      const response = await fetch(url);

      if (response.status >= 300 || response.status < 200) {
        directDownload();
      } else {
        $downloadButtons.addClass('disabled');
        const contentLength = response.headers.get('content-length');
        const total = parseInt(contentLength, 10);
        let loaded = 0;

        const res = new Response(new ReadableStream({
          async start (controller) {
            const reader = response.body.getReader();
            while (true) {
              const {
                done,
                value
              } = await reader.read();

              if (done) break;
              loaded += value.byteLength;

              statusMsg = INKIVE.TranslateHelper.translate('general.downloading',
                { percentage: Math.round(loaded / total * 100) });
              updateStatus();
              controller.enqueue(value);
            }
            controller.close();
          }
        }));
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = fileName || fileURL.match(/[^/]+$/)[0];
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);

        $downloadButtons.removeClass('disabled');
        statusMsg = INKIVE.TranslateHelper.translate('general.download_complete');
        updateStatus();
      }
    }

    function status () {
      INKIVE.EditorFacade.trigger('status.update', {
        msg: statusMsg,
        force: true
      });
    }

    function directDownload () {
      if (url !== fileURL) {
        url = fileURL;
        fetchUrl(url);
      }
    }
  };

  INKIVE.Helpers.toolAttr = {};
  INKIVE.Helpers.setToolAttr = function (type, attr) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const nowAttr = $.extend({}, canvas.getCurStyle());
    $.extend(nowAttr, attr);
    let target;

    switch (type) {
      case 'object':
      case 'rect':
      case 'ellipse':
        target = INKIVE.Helpers.toolAttr.object = nowAttr;
        break;
      case 'line':
      case 'path':
        target = INKIVE.Helpers.toolAttr.path = nowAttr;
        break;
      case 'text':
        target = INKIVE.Helpers.toolAttr.text = nowAttr;
        break;
    }

    canvas.setCurStyle(target);
  };

  INKIVE.Helpers.getColor = function (selected, type) {
    function getElementColor (elem, type) {
      let hex;

      type = type || 'fill';
      if (type === 'background') {
        const color = $(elem).parent().find('rect');
        hex = color.attr('fill');
        return hex || 'none';
      }

      hex = $(elem).attr(type);
      if (!hex || hex === 'null' || hex === 'none') {
        $(elem).children().each(function (index, element) {
          hex = getElementColor(element, type);
          if (hex) return false;
        });
      }

      return !hex || hex === 'null' || hex === 'none' ? null : hex;
    }

    if (_.isArray(selected)) {
      selected = selected[0];
    }

    if (type.split('_')[0] === 'set') {
      const subElements = INKIVE.DesignFacade.getters.sticker.getElementsWithColor(selected);
      const i = parseInt(type.split('_')[1]);

      return getElementColor(subElements[i]) || defaultColor();
    } else {
      if ($(selected).hasClass('textarea')) {
        return new INKIVE.Text.Textarea().setDOM(selected).text[type];
      } else {
        return getElementColor(selected, type) || defaultColor();
      }
    }

    function defaultColor () {
      return type === 'stroke' ? null : '#000000';
    }
  };

  INKIVE.Helpers.resize = function (elem, maxWidth, maxHeight, offsetX, offsetY) {
    const svgroot = $('#svgroot').get(0);

    let nBb = elem.getBBox();

    maxWidth = maxWidth || nBb.width;
    maxHeight = maxHeight || nBb.height;
    offsetX = offsetX || 0;
    offsetY = offsetY || 0;

    let translate = svgroot.createSVGTransform();
    const scale = svgroot.createSVGTransform();
    const rtranslate = svgroot.createSVGTransform();

    const tlist = svgedit.transformlist.getTransformList(elem);

    translate.setTranslate(0, 0);

    const aspectW = (maxWidth - offsetX) / nBb.width;
    const aspectH = (maxHeight - offsetY) / nBb.height;
    const scaleVal = (aspectW >= aspectH) ? aspectH : aspectW;

    scale.setScale(scaleVal, scaleVal);
    rtranslate.setTranslate(0, 0);

    tlist.appendItem(translate);
    tlist.appendItem(scale);
    tlist.appendItem(rtranslate);

    svgedit.recalculate.recalculateDimensions(elem, nBb);

    translate = svgroot.createSVGTransform();

    nBb = elem.getBBox();

    const translateX = -nBb.x + (maxWidth / 2 - nBb.width / 2);
    const translateY = -nBb.y + (maxHeight / 2 - nBb.height / 2);

    translate.setTranslate(translateX, translateY);
    tlist.appendItem(translate);
    svgedit.recalculate.recalculateDimensions(elem);
  };

  INKIVE.Helpers.getUnusedId = function (container) {
    let newId;
    const editor = INKIVE.Tool.getInstance().editor;

    do { newId = editor.getNextId(); }
    while ($(container).find('#' + newId).length);

    return newId;
  };

  INKIVE.Helpers.getStickerFromSvg = function () {
    const svgroot = $('#svgroot').get(0);

    // Get main dimensions
    const mainBB = $('#svgcontent .main').get(0).getBBox();
    const mainWidth = mainBB.width;
    const mainHeight = mainBB.height;

    if (!mainHeight || !mainHeight) {
      return;
    }

    const nSvg = document.createElementNS(svgedit.NS.SVG, 'svg');
    nSvg.setAttribute('width', mainWidth);
    nSvg.setAttribute('height', mainHeight);
    nSvg.setAttribute('xml:space', 'preserve');
    nSvg.setAttribute('enable-background', 'new 0 0 %s %s'.sprintf(mainWidth, mainHeight));
    nSvg.setAttribute('viewBox', '0 0 %s %s'.sprintf(mainWidth, mainHeight));

    const stickerSaveData = document.createElementNS(svgedit.NS.SVG, 'g');

    svgedit.utilities.assignAttributes(stickerSaveData, {
      style: 'pointer-events:none',
      class: 'stickerSaveData'
    });

    $(stickerSaveData).insertBefore($('#svgcontent .main'));

    const $children = $('#svgcontent .main').find('>.element');
    $children.each(function (index, elem) {
      copyElement(elem);
    });

    $(stickerSaveData).remove();

    return INKIVE.Helpers.serializeToString(nSvg);

    function copyElement (elem) {
      if (!elem) return;

      // copy each sticker subelement
      if ($(elem).hasClass('sticker')) {
        const subElements = _.without(INKIVE.DesignFacade.getters.sticker.getElements(elem), elem);

        _.each(subElements, copyElement);
      } else { // Regular elements
        // ignore
        if ($(elem).is('rect.background')) {
          return;
        }

        const $clone = $(elem).clone();
        const cElem = $clone.get(0);
        cElem.removeAttribute('class');

        if ($(elem).hasClass('layoutBox')) {
          const clipPath = svgedit.utilities.getClipPath(elem);

          // Copy clippath with new id
          const clipPathCopy = copyElement(clipPath);

          cElem.setAttribute('class', 'layoutBox element');
          $clone.attr('clip-path', 'url(#' + clipPathCopy.childNodes[0].getAttribute('id') + ')');
        }

        let tlist;
        if ($(elem).is('clippath')) {
          $clone.attr('id', INKIVE.Math.generateUUID());
          tlist = svgedit.transformlist.getTransformList(cElem.childNodes[0]);
        } else if ($(elem).hasClass('textarea')) {
          cElem.setAttribute('class', 'textarea element');
          tlist = svgedit.transformlist.getTransformList(cElem);
        } else {
          $clone.removeAttr('id');
          tlist = svgedit.transformlist.getTransformList(cElem);
        }

        stickerSaveData.appendChild(cElem);

        // Translate
        const translate = svgroot.createSVGTransform();

        const translateX = -mainBB.x;
        const translateY = -mainBB.y;

        translate.setTranslate(translateX, translateY);
        tlist.appendItem(translate);

        if ($(elem).is('clippath')) {
          svgedit.recalculate.recalculateDimensions(cElem.childNodes[0]);
        } else {
          svgedit.recalculate.recalculateDimensions(cElem);
        }

        let svgElem = $(cElem).clone().get(0);

        if ($(elem).is('clippath')) {
          let defs = $(nSvg).find('defs').get(0);
          if (!defs) {
            defs = window.document.createElementNS(svgedit.NS.SVG, 'defs');
            defs.setAttribute('id', 'placeholder_defs');
          }

          defs.appendChild(svgElem);
          svgElem = defs;
        }

        // Append Element tosvg
        nSvg.appendChild(svgElem);

        return svgElem;
      }
    }
  };

  /** ** Converters ******************************************************************************************************/
  INKIVE.Helpers.converterLayoutSizeChange = function (width, height, oldWidth, oldHeight) {
    const editor = INKIVE.Tool.getInstance().editor;
    const canvas = editor.canvas;
    const svgroot = $('#svgroot').get(0);

    if (width === oldWidth && height === oldHeight) {
      return;
    }

    if (width !== canvas.contentW || height !== canvas.contentH) {
      console.warn('Layout dimensions is not canvas dimensions');
    }

    // Special case for background
    const $bg = $('#svgcontent g.background image');
    if ($bg.length) {
      const elem = $bg[0];
      const bbox = elem.getBBox();

      if (!bbox.width) {
        bbox.width = width;
      }
      if (!bbox.height) {
        bbox.height = height;
      }

      const scaleX = width / bbox.width;
      const scaleY = height / bbox.height;

      const scale = Math.max(scaleX, scaleY);

      svgedit.transformlist.removeElementFromListMap(elem);
      const transformlist = svgedit.transformlist.getTransformList(elem);

      const translate = svgroot.createSVGTransform();
      const scaling = svgroot.createSVGTransform();
      const rtranslate = svgroot.createSVGTransform();

      translate.setTranslate(0, 0);
      scaling.setScale(scale, scale);
      rtranslate.setTranslate(0, 0);

      transformlist.appendItem(translate);
      transformlist.appendItem(scaling);
      transformlist.appendItem(rtranslate);

      svgedit.recalculate.recalculateDimensions(elem);

      elem.setAttribute('x', -(bbox.width * scale - width) / 2);
      elem.setAttribute('y', -(bbox.height * scale - height) / 2);
    }

    // Cases for regular elements
    $('#svgcontent .element:not(.subelement)').each(function (index, elem) {
      if ($(elem).is('#svgcontent g.background rect')) {
        return true;
      }
      const scaleX = width / oldWidth;
      const scaleY = height / oldHeight;

      svgedit.transformlist.removeElementFromListMap(elem);

      const transformlist = svgedit.transformlist.getTransformList(elem);

      const bb = svgedit.utilities.getBBox(elem);

      let scale = ((parseInt(scaleX * oldWidth) <= width) && (parseInt(scaleX * oldHeight) <= height)) ? scaleX : scaleY;

      // Special case for full size elements
      if (bb.x <= 0 && bb.y <= 0 && bb.width >= oldWidth && bb.height >= oldHeight) {
        scale = scale === scaleX ? scaleY : scaleX;
      }

      const translate = svgroot.createSVGTransform();
      const scaling = svgroot.createSVGTransform();
      const rtranslate = svgroot.createSVGTransform();

      // Scale element
      translate.setTranslate(0, 0);
      scaling.setScale(scale, scale);
      rtranslate.setTranslate(0, 0);

      transformlist.appendItem(translate);
      transformlist.appendItem(scaling);
      transformlist.appendItem(rtranslate);

      svgedit.recalculate.recalculateDimensions(elem);

      const nbb = svgedit.utilities.getBBox(elem);

      // Create a new transform list to move element to new coordinates
      // (important)
      const xform = svgroot.createSVGTransform();
      const tlist = svgedit.transformlist.getTransformList(elem);

      /**
       * 1. find vector from old center
       * 2. find proposal vector from new center ( * scale)
       * 3. find real proposal coordinates (from new sizes)
       * 4. find real coordinates (by new coords)
       */
      xform.setTranslate(
        width / 2 - (oldWidth / 2 - bb.x) * scale - nbb.x,
        height / 2 - (oldHeight / 2 - bb.y) * scale - nbb.y);

      tlist.appendItem(xform);

      svgedit.recalculate.recalculateDimensions(elem);

      canvas.removeFromSelection([elem]);
    });
  };

  INKIVE.Helpers.areEqual = function (SVGContent1, SVGContent2) {
    const elm1 = getElement(SVGContent1);
    const elm2 = getElement(SVGContent2);

    elm1.nodeName === 'svg' && elm1.removeAttribute('xmlns:xlink');
    elm2.nodeName === 'svg' && elm2.removeAttribute('xmlns:xlink');

    if (!elm1.getAttribute('id') || !elm2.getAttribute('id')) {
      elm1.removeAttribute('id');
      elm2.removeAttribute('id');
    }

    const attrs1 = getAttributeNames(elm1);
    const attrs2 = getAttributeNames(elm2);

    return hasSameAttributes() &&
      hasSameAttributValues() &&
      hasSameContent();

    function hasSameAttributes () {
      return attrs1.join(',') === attrs2.join(',');
    }

    function hasSameAttributValues () {
      return _.all(attrs1, function (attrName) {
        let attrValue1 = elm1.getAttribute(attrName);
        let attrValue2 = elm2.getAttribute(attrName);
        const originalString = 'original';

        if (attrName === 'xlink:href') {
          attrValue1 = INKIVE.ImagesFactory.getVersionUrl(attrValue1, originalString);
          attrValue2 = INKIVE.ImagesFactory.getVersionUrl(attrValue2, originalString);
        }

        return attrValue1 === attrValue2;
      });
    }

    function hasSameContent () {
      let node1 = elm1.firstChild;
      let node2 = elm2.firstChild;

      while (node1 && node2) {
        bypassEmptyNodes();

        if (node1 && node2) {
          if (!isSameNode()) return false;
          node1 = node1.nextSibling;
          node2 = node2.nextSibling;
        }
      }

      bypassEmptyNodes();

      return node1 === node2;

      function bypassEmptyNodes () {
        while (isEmptyTextNode(node1)) { node1 = node1.nextSibling; }
        while (isEmptyTextNode(node2)) { node2 = node2.nextSibling; }
      }

      function isEmptyTextNode (node) {
        return node &&
          node.nodeType === 3 &&
          node.nodeValue.replace('&nbsp;', '').trim() === '';
      }

      function isSameNode () {
        return node1.nodeType === node2.nodeType && isSameContent();
      }

      function isSameContent () {
        if (node1.nodeType === 1 && node1.nodeValue !== node2.nodeValue) {
          return false;
        }

        if (node1.nodeType === 3 && node1.nodeValue.trim() !== node2.nodeValue.trim()) {
          return false;
        }

        if (node1.nodeType === 1) {
          return INKIVE.Helpers.areEqual(node1, node2);
        }

        return true;
      }
    }

    function getElement (SVGContent) {
      if (SVGContent instanceof Node) {
        return SVGContent;
      }

      const elm = document.createElement('div');
      elm.innerHTML = SVGContent;
      return elm;
    }

    function getAttributeNames (node) {
      return _.map(node.attributes, function (attr) {
        return attr.nodeName;
      }).sort();
    }
  };

  INKIVE.Helpers.converterCurrentPage = converterCurrentPage;

  INKIVE.Helpers.displayImagesLoadingAnimation = function () {
    const editor = INKIVE.Tool.getInstance().editor;

    editor.canvas.call('loading.hide_all');
    $('#svgcontent').find('image').each(function () {
      const image = this;
      const onload = _.once(hideLoader);
      const url = image.getAttribute('xlink:href');

      if (!url || image.getAttribute('opacity') === '0') {
        return;
      }

      if (!image.complete) {
        const mockImage = new Image();
        mockImage.onload = onload;
        mockImage.src = url;

        editor.canvas.call('loading.show', image);
        _.delay(onload, 30000);
      }

      function hideLoader () {
        editor.canvas.call('loading.hide', image);
      }
    });
  };

  INKIVE.Helpers.calculatePngSize = function (width, height) {
    return INKIVE.Helpers.formatBytes((width * height * 24) / 8);
  };

  INKIVE.Helpers.calculateJpegSize = function (width, height, quality) {
    return INKIVE.Helpers.formatBytes((width * height * 3) / 8 * quality / 100);
  };

  INKIVE.Helpers.formatBytes = function (bytes, decimals) {
    if (bytes === 0) return '0 Byte';
    const k = 1000;
    const dm = decimals + 1 || 3;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toPrecision(dm) + ' ' + sizes[i];
  };

  INKIVE.Helpers.fillArray = function (value, len) {
    const arr = [];
    for (let i = 0; i < len; i++) {
      arr.push(value);
    }
    return arr;
  };

  INKIVE.Helpers.getBucketUrl = function (bucketData) {
    bucketData = bucketData.match(/([^.]*)\.(inkive|webrand|desygner)\.com/);
    if (!bucketData) return;

    const region = bucketData[1];
    const domain = bucketData[2];

    switch (region) {
      case 'assets': return 'https://s3.amazonaws.com/assets.' + domain + '.com/assets';
      case 'sydney': return 'https://s3-ap-southeast-2.amazonaws.com/sydney.' + domain + '.com/sydney';
      case 'singapore': return 'https://s3-ap-southeast-1.amazonaws.com/singapore.' + domain + '.com/singapore';
      case 'tokyo': return 'https://s3-ap-northeast-1.amazonaws.com/tokyo.' + domain + '.com/tokyo';
      case 'california': return 'https://s3-us-west-1.amazonaws.com/california.' + domain + '.com/california';
      case 'ireland': return 'https://s3-eu-west-1.amazonaws.com/ireland.' + domain + '.com/ireland';
      case 'oregon': return 'https://s3-us-west-2.amazonaws.com/oregon.' + domain + '.com/oregon';
      case 'sao-paulo': return 'https://s3-sa-east-1.amazonaws.com/sao-paulo.' + domain + '.com/sao-paulo';
      case 'virginia-testing': return 'https://s3.amazonaws.com/virginia-testing.' + domain + '.com/virginia-testing';
      case 'virginia':
      default: return 'https://s3.amazonaws.com/virginia.' + domain + '.com/virginia';
    }
  };

  INKIVE.Helpers.getImageUrl = function (encodedDesignId, imageSize) {
    const bucketUrl = INKIVE.Helpers.getBucketUrl(INKIVE.C.BUCKET);
    return bucketUrl +
      '/' + imageSize +
      '/' + INKIVE.C.BOOK.id +
      '/' + encodedDesignId + '.jpg';
  };

  INKIVE.Helpers.getFormValue = function (form, param) {
    const values = {};

    $.each($(form).serializeArray(), function (i, field) {
      values[field.name] = field.value;
    });

    // Value Retrieval Function
    const getValue = function (valueName) {
      return values[valueName];
    };

    // Retrieve the Values
    const ret = getValue(param);
    return ret;
  };

  INKIVE.Helpers.serializeToString = function (element) {
    const serializer = new XMLSerializer();
    return serializer.serializeToString(element).replace('<svg:svg', '<svg').replace('</svg:svg>', '</svg>');
  };

  INKIVE.Helpers.getActiveTab = function () {
    let active;

    _.each(INKIVE.Tabs, function (element, key) {
      if (element.$el.is('.active')) {
        active = key;
      }
    });

    return active;
  };

  INKIVE.Helpers.getSystemJsUrl = function (url) {
    url = url.replace(/^\/+/, '');

    if (INKIVE.C.IS_DEV) {
      return (INKIVE.C.IS_WEBRAND ? INKIVE.C.WE_BRAND : INKIVE.C.BASE_URL) + url + '?t=' + _.now();
    }

    const isLive = /^v\d+\.\d+\.\d+$/.test(INKIVE.C.WB_VERSION);
    const match = url.match(/^(.+)config\.js$/);

    if (match) {
      const versionSlug = INKIVE.C.WB_VERSION.replace(/\//g, '-').replace(/\./g, '_');
      url = `${match[1]}config--${versionSlug}.js`;
    }

    return isLive
      ? `https://static.desygner.com/assets/build/${url}`
      : `https://s3.amazonaws.com/assets.desygner.com/assets/build/${url}`;
  };

  INKIVE.Helpers.getScript = function (url, callback) {
    // Rewriting getScript because it makes no sense and invalidate cache intentionally
    return $.ajax({
      url,
      type: 'get',
      dataType: 'script',
      success: callback,
      cache: true
    });
  };

  INKIVE.Helpers.getStyle = function (url, id) {
    const link = document.createElement('link');
    if (id) link.id = id;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    link.media = 'all';

    document.head.appendChild(link);
  };

  INKIVE.Helpers.getAureliaLibraries = (function () {
    return function ($container) {
      const moduleDeferred = $.Deferred();

      if (INKIVE.Helpers.systemDeferred) {
        INKIVE.Helpers.systemDeferred.then(initializeModule);
      } else {
        INKIVE.Helpers.systemDeferred = $.Deferred();
        loadSystemJs();
      }

      return moduleDeferred;

      function loadSystemJs () {
        const getSystemJsUrl = INKIVE.Helpers.getSystemJsUrl;
        const baseUrl = INKIVE.C.IS_WEBRAND ? INKIVE.C.WE_BRAND : INKIVE.C.BASE_URL;

        INKIVE.Helpers.getScript(getSystemJsUrl('/vendor/system.js')).then(function () {
          System.config({ baseURL: baseUrl });

          INKIVE.Helpers.getScript(getSystemJsUrl('/bundles/desygnerbrand/config.js')).then(function () {
            System.registerDynamic('jquery', [], false, function (require, exports, module) {
              module.exports = window.jQuery;
            });

            autoloadModule();
          });
        });
      }

      function autoloadModule () {
        System.import('aurelia-bootstrapper').then(function (aurelia) {
          handleMutationEvent([$container.get(0)], () => {
            INKIVE.Helpers.systemDeferred.resolve(aurelia.bootstrap);
            moduleDeferred.resolve();
          }, ['DOMSubtreeModified'], { once: true });
        });
      }

      function initializeModule (bootstrap) {
        const appHost = $container[0];
        const moduleId = appHost.getAttribute('aurelia-app');

        System.import(moduleId).then(function (module) {
          bootstrap(function (aurelia) {
            aurelia.host = appHost;
            aurelia.configModuleId = moduleId || null;

            module.configure(aurelia);
            handleMutationEvent([$container.get(0)], moduleDeferred.resolve, ['DOMSubtreeModified'], { once: true });
          });
        });
      }
    };
  })();

  INKIVE.Helpers.getSecureUrl = function (url) {
    if (INKIVE.C.IS_DEV) {
      return (INKIVE.C.IS_WEBRAND ? INKIVE.C.WE_BRAND : INKIVE.C.BASE_URL) + url + '?t=' + _.now();
    }

    const isLive = /^v\d+\.\d+\.\d+$/.test(INKIVE.C.WB_VERSION);

    return isLive
      ? 'https://static.webrand.com/build/' + INKIVE.C.WB_VERSION + url + '?' + INKIVE.C.WB_VERSION
      : 'https://s3.amazonaws.com/assets.webrand.com/build/' + INKIVE.C.WB_VERSION + url + '?' + INKIVE.C.WB_VERSION;
  };

  INKIVE.Helpers.getStripeScript = function () {
    window.Stripe || INKIVE.Helpers.getScript('https://js.stripe.com/v3');
  };

  INKIVE.Helpers.getPriceString = function (total, currency) {
    // total = (total && total.toFixed) ? total.toFixed(2) : total;

    switch (currency.toLowerCase()) {
      case 'ndz': return 'NZ $' + total;
      case 'usd': return 'US $' + total;
      case 'cad': return 'CA $' + total;
      case 'eur': return '€ ' + total;
      case 'aed': return 'AED ' + total;
      case 'afn': return 'Af ' + total;
      case 'all': return 'ALL ' + total;
      case 'amd': return 'AMD ' + total;
      case 'ars': return total + ' AR$';
      case 'aud': return 'AU $' + total;
      case 'azn': return 'man. ' + total;
      case 'bam': return 'KM ' + total;
      case 'bdt': return 'Tk ' + total;
      case 'bgn': return 'BGN ' + total;
      case 'bhd': return 'BD ' + total;
      case 'bif': return 'FBu ' + total;
      case 'bnd': return 'BN $' + total;
      case 'bob': return 'Bs ' + total;
      case 'brl': return 'R $' + total;
      case 'bwp': return 'BWP ' + total;
      case 'byr': return 'BYR ' + total;
      case 'bzd': return 'BZ $' + total;
      case 'cdf': return 'CDF ' + total;
      case 'chf': return 'CHF ' + total;
      case 'clp': return total + ' CL$';
      case 'cny': return 'CN¥ ' + total;
      case 'cop': return total + ' CO$';
      case 'crc': return '₡ ' + total;
      case 'cve': return 'CV $' + total;
      case 'czk': return 'Kč ' + total;
      case 'djf': return 'Fdj ' + total;
      case 'dkk': return 'Dkr ' + total;
      case 'dop': return total + ' RD$';
      case 'dzd': return 'DA ' + total;
      case 'eek': return 'Ekr ' + total;
      case 'egp': return 'EGP ' + total;
      case 'ern': return 'Nfk ' + total;
      case 'etb': return 'Br ' + total;
      case 'gbp': return '£ ' + total;
      case 'gel': return 'GEL ' + total;
      case 'ghs': return 'GH₵ ' + total;
      case 'gnf': return 'FG ' + total;
      case 'gtq': return 'GTQ ' + total;
      case 'hkd': return 'HK $' + total;
      case 'hnl': return 'HNL ' + total;
      case 'hrk': return 'kn ' + total;
      case 'huf': return 'Ft ' + total;
      case 'idr': return 'Rp ' + total;
      case 'ils': return '₪ ' + total;
      case 'inr': return 'Rs ' + total;
      case 'iqd': return 'IQD ' + total;
      case 'irr': return 'IRR ' + total;
      case 'isk': return 'Ikr ' + total;
      case 'jmd': return 'J $' + total;
      case 'jod': return 'JD ' + total;
      case 'jpy': return '¥ ' + total;
      case 'kes': return 'Ksh ' + total;
      case 'khr': return 'KHR ' + total;
      case 'kmf': return 'CF ' + total;
      case 'krw': return '₩ ' + total;
      case 'kwd': return 'KD ' + total;
      case 'kzt': return 'KZT ' + total;
      case 'lbp': return 'LB£ ' + total;
      case 'lkr': return 'SLRs ' + total;
      case 'ltl': return 'Lt ' + total;
      case 'lvl': return 'Ls ' + total;
      case 'lyd': return 'LD ' + total;
      case 'mad': return 'MAD ' + total;
      case 'mdl': return 'MDL ' + total;
      case 'mga': return 'MGA ' + total;
      case 'mkd': return 'MKD ' + total;
      case 'mmk': return 'MMK ' + total;
      case 'mop': return 'MOP $' + total;
      case 'mur': return 'MURs ' + total;
      case 'mxn': return total + ' MX$';
      case 'myr': return 'RM ' + total;
      case 'mzn': return 'MTn ' + total;
      case 'nad': return 'N $' + total;
      case 'ngn': return '₦ ' + total;
      case 'nio': return 'C $' + total;
      case 'nok': return 'Nkr ' + total;
      case 'npr': return 'NPRs ' + total;
      case 'nzd': return 'NZ $' + total;
      case 'omr': return 'OMR ' + total;
      case 'pab': return 'B/. ' + total;
      case 'pen': return 'S/. ' + total;
      case 'php': return '₱ ' + total;
      case 'pkr': return 'PKRs ' + total;
      case 'pln': return 'zł ' + total;
      case 'pyg': return '₲ ' + total;
      case 'qar': return 'QR ' + total;
      case 'ron': return 'RON ' + total;
      case 'rsd': return 'din. ' + total;
      case 'rub': return 'RUB ' + total;
      case 'rwf': return 'RWF ' + total;
      case 'sar': return 'SR ' + total;
      case 'sdg': return 'SDG ' + total;
      case 'sek': return 'Skr ' + total;
      case 'sgd': return 'S $' + total;
      case 'sos': return 'Ssh ' + total;
      case 'syp': return 'SY£ ' + total;
      case 'thb': return '฿ ' + total;
      case 'tnd': return 'DT ' + total;
      case 'top': return 'T $' + total;
      case 'try': return 'TL ' + total;
      case 'ttd': return 'TT $' + total;
      case 'twd': return 'NT $' + total;
      case 'tzs': return 'TSh ' + total;
      case 'uah': return '₴ ' + total;
      case 'ugx': return 'USh ' + total;
      case 'uyu': return total + '$U';
      case 'uzs': return 'UZS ' + total;
      case 'vef': return 'Bs.F. ' + total;
      case 'vnd': return '₫ ' + total;
      case 'xaf': return 'FCFA ' + total;
      case 'xof': return 'CFA ' + total;
      case 'yer': return 'YR ' + total;
      case 'zar': return 'R ' + total;
      case 'zmk': return 'ZK ' + total;
    }

    return total;
  };
  INKIVE.Helpers.projectCreatedInLastMinutes = function (minutes) {
    const creationDate = new Date(parseInt(INKIVE.C.BOOK.create_date) * 1000);

    minutes = minutes || 2;
    return _.now() - creationDate < minutes * 60 * 1000;
  };

  INKIVE.Helpers.getHeader = function (allHeaders, key) {
    const headers = {};

    _.each(_.map(allHeaders.trim().split(/[\r\n]+/), function (value) {
      return value.split(/: /);
    }), function (keyValue) {
      headers[keyValue[0].trim()] = keyValue[1].trim();
    });

    return headers[key];
  };

  INKIVE.Helpers.mapUrlToCloudFront = (url, upscale = false) => {
    /*
     * See [Cloudfront map](https://desygner.atlassian.net/l/c/f2011P1F)
     *
     * Examples:
     * https://static.inkive.me/virginia/web/a660ac6d-71cc-4e3f-b509-fdc808a7090e.jpg -> https://s3.amazonaws.com/virginia.inkive.com/virginia/web/a660ac6d-71cc-4e3f-b509-fdc808a7090e.jpg
     * https://static.qadesygner.xyz/mobile/repository/p/ed32b10a20f61c3e81584104ee44469efe76e6dc18b7164491f3c21920.jpg -> http://giles.photodexia.com/mobile/repository/p/ed32b10a20f61c3e81584104ee44469efe76e6dc18b7164491f3c21920.jpg
     */

    // Upscale format to original
    if (upscale) url = url.replace(/\/largeweb\/|\/web\/|\/tab\/|\/mobile\/|\/thumb\//g, '/original/');

    const parts = url.match(/\w+(\/.*)/);
    if (parts.length === 2) {
      if (url.includes('/repository/p/')) {
        return 'http://giles.photodexia.com' + parts[1];
      }

      if (url.includes('static.inkive.me/virginia/company')) {
        // Video urls should map to s3
        return `https://s3.amazonaws.com/virginia-testing.webrand.com${parts[1]}`;
      }

      if (url.includes('static.inkive.me/virginia-testing/')) {
        return `https://virginia-testing.webrand.com${parts[1]}`;
      }

      if (url.includes('/company/') || url.includes('virginia.webrand.com')) {
        return `https://s3.amazonaws.com/virginia.webrand.com${parts[1]}`;
      } else if (url.includes('/virginia/')) {
        return `https://s3.amazonaws.com/virginia.inkive.com${parts[1]}`;
      }
    }
    return url;
  };

  INKIVE.Helpers.delay = (t, v) => {
    return new Promise(function (resolve) {
      setTimeout(resolve.bind(null, v), t);
    });
  };

  INKIVE.Helpers.changePageAwait = async (i) => {
    await INKIVE.EditorFacade.handle('page', 'move_to', {
      page_number: i + 1,
      quiet: true,
      save: true
    });

    // Wait for 4 sec per page
    // EditorFacade.on(page.move_to) doesn't wait
    // for all assets to fully load before resolving
    // TODO: Create function that listens for fonts & images to load
    await INKIVE.Helpers.delay(4000);
  };

  INKIVE.Helpers.currPage = () => INKIVE.Tool._current_page_number - 1;

  INKIVE.Helpers.getSvgUrl = (svg) => URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));

  INKIVE.Helpers.getInlineSize = getInlineSize;

  INKIVE.Helpers.slugify = function (text) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-.]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  };

  INKIVE.Helpers.generateRandomString = function (size) {
    const collection = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890-_';
    let i;
    const result = [];
    size = size || 15;

    while (size-- > 0) {
      i = Math.floor(Math.random() * result.length);
      result.push(collection[i]);
    }

    return result;
  };

  INKIVE.Helpers.removeClassDimensions = function () {
    const svgContent = document.getElementById('svgcontent');

    if (!svgContent) return;

    const list = Array.from(svgContent.classList);

    list.forEach(function (className) {
      className.match(/du-[\w+]/) && svgContent.classList.remove(className);
      className.match(/dw-[\d|\.]+/) && svgContent.classList.remove(className);
      className.match(/dh-[\d|\.]+/) && svgContent.classList.remove(className);
    });
  };

  INKIVE.Helpers.isInlineSizeValid = function () {
    const inlineSize = getInlineSize();

    return Object.keys(inlineSize).length === 3 &&
      !isNaN(parseFloat(inlineSize?.width)) &&
      !isNaN(parseFloat(inlineSize?.height)) &&
      Object.prototype.hasOwnProperty.call(inlineSize, 'unit') &&
      inlineSize.unit.length === 2;
  };

  INKIVE.Helpers.sanitizeIgnoredTagsSvg = sanitizeIgnoredTagsSvg;
  INKIVE.Helpers.sanitizeIgnoredSaveTagsSvg = sanitizeIgnoredSaveTagsSvg;
  INKIVE.Helpers.getLineArray = getLineArray;
  INKIVE.Helpers.getCursorLineIndex = getCursorLineIndex;
  INKIVE.Helpers.getStylingPart = getStylingPart;
  INKIVE.Helpers.registerMutationObserver = handleMutationEvent;
};
